const RoomService = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="icon-room-service"
      data-name="icon-room-service"
      viewBox="0 0 24 24"
      fill="currentColor"
      width={_width}
      {...props}
    >
      <path d="M23,19V17A11.01,11.01,0,0,0,13,6.051V4.723a2,2,0,1,0-2,0V6.051A11.01,11.01,0,0,0,1,17v2a1,1,0,0,0,0,2H23A1,1,0,0,0,23,19ZM3,17C3.473,5.066,20.531,5.075,21,17v2H3Z" />
    </svg>
  );
};

export default RoomService;
